import { Box, Stack, Typography } from '@mui/material';

export function TitledResultBox({ title, value, showBorder = true }) {
  return (
    <Box sx={{ border: showBorder ? '1px solid black' : 'none', width: '460px' }}>
      <Stack direction="column" alignItems="center">
        <Typography variant="h6" color="textPrimary" component="h6">
          {title}
        </Typography>
        <Typography variant="h6" color="textPrimary" component="h6">
          {value}
        </Typography>
      </Stack>
    </Box>
  );
}
